/**
 * @generated SignedSource<<0aa6d011e94acbe1dbde8ada4819bf3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsPlusPage$data = {
  readonly urlAlias: string;
  readonly " $fragmentType": "helpersCheckIsPlusPage";
};
export type helpersCheckIsPlusPage$key = {
  readonly " $data"?: helpersCheckIsPlusPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusPage">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsPlusPage"
};

(node as any).hash = "02a31651300a73ceff70bbd66e4d9a4f";

export default node;
